import { jsxs, jsx } from "react/jsx-runtime";
import Typography from "../Typography/Typography.js";
import classnames from "../../utils/classnames.js";
import Col from "../Grid/Col.js";
import "react";
import Row from "../Grid/Row.js";
import '../Grid/Grid.css';/* empty css                */
const DealerInfoExtra = ({ label, value, className }) => {
  if (!value) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Row, { gutter: [0, "vertical-purple"], className: classnames("perxis-auto-dealer-info-extra", className), children: [
    !!label && /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsxs(Typography.Text, { color: "dark-light", level: "small", className: classnames("perxis-auto-dealer-info-extra__label"), children: [
      label,
      ":"
    ] }) }),
    /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "dark", className: classnames("perxis-auto-dealer-info-extra__value"), children: typeof value === "string" ? /* @__PURE__ */ jsx("span", { dangerouslySetInnerHTML: { __html: value } }) : value }) })
  ] });
};
export {
  DealerInfoExtra as default
};
//# sourceMappingURL=DealerInfoExtra.js.map
